import React, { Component } from 'react';
import { connect } from "react-redux";
import _ from 'lodash';

import { WithStyles, createStyles, Typography, Button, Modal, Card, CardContent, CardActions, CardHeader, IconButton, FormControl, InputLabel, Select, MenuItem, Grid, Paper, Link, TableHead, Table, TableBody, TextField ,Checkbox,ListItemText } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import { bindActionCreators } from "redux";

import { RequestDetailStyle } from "../styles/RequestDetailStyle";
import contentRequestServices from "../services/contentRequestServices";
import {
  fetchOwners
} from '../actions/contentRequestActions'
import  { contentRequestActions }  from "../reducers/contentRequestReducer.js";
import CustomInfoIcon from "../../common/CustomInfoIcon";
import MyPATMultiSearch from '../../common/MyPATMultiSearch';
import Avatar from '@material-ui/core/Avatar';
import classNames from 'classnames';


interface RequestSubjectCardProps extends WithStyles<typeof RequestDetailStyle> {
    classes: any,
    handleDialog:Function,
    subject:any ,
    selectedSubjects:string [],
    fetchOwners: Function,
    owners:any [],
    list:any [],
    transferToParent:Function,
    selectedValue:string;
    isDisabled?: boolean;

}



interface RequestSubjectCardStates {
 renderSubjects:any [],
 selectedOptions:any [],
 currentValue:string
}


class RequestSubjectCard extends Component<RequestSubjectCardProps, RequestSubjectCardStates>{	
  imgData: any = {
		physics: '/assets/svg/myLibrary/physics.svg',
		chemistry: '/assets/svg/myLibrary/chemistry.svg',
		mathematics: '/assets/svg/myLibrary/mathematics.svg',
		english: '/assets/svg/myLibrary/english.svg',
		hindi: '/assets/svg/myLibrary/hindi.svg',
		socialscience: '/assets/svg/myLibrary/socialscience.svg',
		mat: '/assets/svg/myLibrary/mat.svg',
		logicalreasoning: '/assets/svg/myLibrary/logicalreasoning.svg',
		biology: '/assets/svg/myLibrary/biology.svg',
		generalknowledge: '/assets/svg/myLibrary/generalknowledge.svg',
	}
   constructor(props: RequestSubjectCardProps) {
        super(props);
        this.state={
          renderSubjects:[],
          selectedOptions:[],
          currentValue:this.props.selectedValue
        }
        
    }
   componentDidMount(){
      
   }
   extractCharacters = (str: string) => {
		let _str = ''
		str.split(' ').map(s =>{
			_str+=s[0].toUpperCase()
		})
		return _str
	}
   handleMultiSelect(selectedValue: any,name:string) {
    console.log("onchange",selectedValue);
    this.setState({currentValue:selectedValue},()=>{ this.props.transferToParent(this.props.subject._id,selectedValue);});
   }
  render(){
       const{classes,handleDialog,subject,selectedSubjects,list, isDisabled}=this.props;
       const{renderSubjects}=this.state;
       console.log("RequestSubject",this.state.currentValue);
       let subjectName = subject.name.split(' ').join('').toLowerCase();
     return (
        <Grid container alignItems="center" className={classNames(classes.requestCardElement, isDisabled && classes.disabledSection)}>  
        <Grid item xs={6}>
        <Grid container alignItems="center" justify="flex-start">
          <Grid item>
          <span className="iconImage">
								{
									this.imgData[subjectName] ? 
									<img src={`/assets/svg/myLibrary/${subjectName}.svg`} alt="subject-icon" /> 
									: <Avatar className={classes.purple}>{this.extractCharacters(subjectName)}</Avatar>
								}
						</span>
          </Grid>
          <Grid item>
            <Grid className="subjectLabel">&nbsp;&nbsp;{subject.name} Request Owners:&nbsp;</Grid>
          </Grid>
        </Grid>
      </Grid>
  
       <Grid item xs={6}>
          <MyPATMultiSearch
              options={list}
              labelKey="name"
              valueKey="id"
              onChange={this.handleMultiSelect.bind(this)}
              values={this.state.currentValue}
              isSearchAble={true}
              name="owners"
              placeholderText="Add Client and user"
        />
        </Grid>
      </Grid>
     ); 
    } 
}
const mapStateToProps = (state:any)=>{
  return {
    //  selectedSubjects:state.contentRequestReducer.contentRequestCreateReducer.selectedSubjects,
    //  owners:state.contentRequestReducer.contentRequestCreateReducer.owners
}};
const mapDispatchToProps =(dispatch:any)=>
bindActionCreators({
//    fetchOwners
},
dispatch);   

// @ts-ignore
export default connect(mapStateToProps,mapDispatchToProps)(withStyles(RequestDetailStyle)(RequestSubjectCard));

